import React, { Component } from 'react';
import { Widget, addResponseMessage, isWidgetOpened } from 'react-chat-widget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ChatMessage = (props) => {
  if(props.role === 'CUSTOMER') {
    return (<></>)
  }

  let message = { __html: props.message }

  return (
    <>
      {props.role == 'AGENT' && (
        <FontAwesomeIcon icon="user" className="rcw-avatar"/>
      )}

      <div className="rcw-response">
        <div className="rcw-message-text" dangerouslySetInnerHTML={message} />
      </div>
    </>
  )
};

export default ChatMessage;
